import { Directive, Inject, Input, Optional } from "@angular/core";
import { NgControl } from "@angular/forms";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { TranslateService } from "@ngx-translate/core";
import { CustomDateFormat, DateDisplay, DateParse } from "../custom-date-format";

@Directive({
  selector: "[datePickerFormat]",
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS,
      useClass: CustomDateFormat
    }
  ]
})
export class DatePickerFormatDirective {
  @Input() public configDateParse: DateParse;
  @Input() public configDateDisplay: DateDisplay;

  @Input("datePickerFormat")
  set datePickerFormat(format: string) {
    var regex = new RegExp(/\b[d]{2}\b/, "g");
    format = format?.replace(regex, 'DD');
    if (this.configDateParse) {
      this.matDateFormat.updateDateFormat(
        this.configDateParse,
        this.configDateDisplay
      );
    } else {
      this.matDateFormat.updateDateFormat({ dateInput: format });    
    }

    const value = this.ngControl.value;
    this.ngControl.valueAccessor?.writeValue(value);
  }

  constructor(
    @Inject(MAT_DATE_FORMATS) public matDateFormat: CustomDateFormat,
    @Optional() private ngControl: NgControl,
    private dateAdapter: DateAdapter<Date>,
    private translate: TranslateService
  ) {
    this.dateAdapter.setLocale(this.translate.currentLang);
  }
}
